module.exports = __webpack_public_path__ + "static/media/clash-of-clans.c2b0f8ae.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/clash-of-clans.webm
// module id = 53
// module chunks = 0